module.exports = __webpack_public_path__ + "img/baloon.03900aa5.svg";